export default __webpack_public_path__ + "static/media/edital9.575a2635.pdf";